var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03033 11.5303C8.73744 11.8232 8.26256 11.8232 7.96967 11.5303L5.46967 9.03033C5.17678 8.73744 5.17678 8.26256 5.46967 7.96967C5.76256 7.67678 6.23744 7.67678 6.53033 7.96967L8.5 9.93934L10.4697 7.96967C10.7626 7.67678 11.2374 7.67678 11.5303 7.96967C11.8232 8.26256 11.8232 8.73744 11.5303 9.03033L9.03033 11.5303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 16.9321 2.63766 17.7153 3.50056 17.9371C3.53409 16.0331 5.088 14.5 7 14.5C8.933 14.5 10.5 16.067 10.5 18H13.5C13.5 16.067 15.067 14.5 17 14.5C18.912 14.5 20.4659 16.0331 20.4994 17.9371C21.3623 17.7153 22 16.9321 22 16V12.75H15V11.25H21.4L18.6005 7.75061C18.2209 7.27618 17.6463 7 17.0387 7H15V6C15 4.89543 14.1046 4 13 4H4ZM8.5 13.5C6.29086 13.5 4.5 11.7091 4.5 9.5C4.5 7.29086 6.29086 5.5 8.5 5.5C10.7091 5.5 12.5 7.29086 12.5 9.5C12.5 11.7091 10.7091 13.5 8.5 13.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDownArrow);
export default __webpack_public_path__ + "static/media/truck-down-arrow.af9a8aa704d35933b88f5631488a4856.svg";
export { ForwardRef as ReactComponent };